import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { ILeadSourceCampaign } from '~/types/leadSource/models'
import type { TEntityId } from '~/types/models'

const leadSourceCampaignListData = undefined as unknown as ILeadSourceCampaign[]

export const getLeadSourceCampaignListData = getListDataFunctionFactory<
  ILeadSourceCampaign[]
>({
  listData: leadSourceCampaignListData,
  storageKey: 'leadsourcecampaigns',
  getStartingListData: getStartingLeadSourceCampaignListData,
})

export async function getLeadSourceCampaignDataById(
  id: TEntityId
): Promise<ILeadSourceCampaign> {
  const list: ILeadSourceCampaign[] = await getLeadSourceCampaignListData()
  if (!list) {
    throw new Error(`getLeadSourceCampaignListData returned undefined/null`)
  }
  const lsc = list.find((leadSourceCampaign) => leadSourceCampaign.id === id)
  if (!lsc) {
    throw new Error(`Can't find leadSourceCampaign '${id}'`)
  }
  return lsc
}

export async function getLeadSourceCampaignDataByDescr(
  descr: string
): Promise<ILeadSourceCampaign> {
  const list: ILeadSourceCampaign[] = await getLeadSourceCampaignListData()
  if (!list) {
    throw new Error(`getLeadSourceCampaignListData returned undefined/null`)
  }
  const lsc = list.find(
    (leadSourceCampaign) => leadSourceCampaign.descr === descr
  )
  if (!lsc) {
    throw new Error(`Can't find leadSourceCampaign '${descr}'`)
  }
  return lsc
}

export async function getStartingLeadSourceCampaignListData(): Promise<
  ILeadSourceCampaign[]
> {
  return [
    {
      id: 'XXLSC0001',
      hrid: 'LSC0001',
      descr: '2023-04 | Consulting Expansion',
      status: { id: 1, label: 'Active' },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXLSC0002',
      hrid: 'LSC0002',
      descr: '2023-05 | Discounted DIA Service',
      status: { id: 1, label: 'Active' },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXLSC0003',
      hrid: 'LSC0003',
      descr: '2023-05  | CCaaS Conversion',
      status: { id: 1, label: 'Active' },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
